import { render, staticRenderFns } from "./OneOrderComponent.vue?vue&type=template&id=c469a83c&"
import script from "./OneOrderComponent.vue?vue&type=script&lang=js&"
export * from "./OneOrderComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports